import * as React from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Padding } from "@mui/icons-material";
import { useEffect, useState } from "react";
import Parse from "../../API/ParseServer";
import styles from "./BlogTab.module.css";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useSearchParams } from "react-router-dom";
interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    // padding: "12px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "black",
    Padding: "3px",
  },
  borderBottom: "2px solid #dad9da",
  boxSizing: "inherit",
  // "& .MuiTabs-indicator": {
  //   backgroundColor: "#1890ff",
  // },
  "& .MuiTabs-scroller": {
    overflow: "scroll !important",
    "&::-webkit-scrollbar": {
      display: "none !important",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(20),
  marginRight: theme.spacing(1),
  color: "gray",
  "&.Mui-selected": {
    color: "black",
    boxShadow: "0 4px #0a0a0a",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "black",
    boxShadow: "0 4px #0a0a0a",
  },
}));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={2}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// export default function CustomizedTabs();
const BlogTab: React.FC<{
  searchPhrase: any;
}> = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [topics, setTopics] = useState<any>([]);
  const [popularTopics, setPopularTopics] = useState<any>([]);
  const [searchParams] = useSearchParams();
  const blogType = searchParams.get("blogType");
  useEffect(() => {
    if (blogType) {
      setValue(1);
    }
  }, [blogType]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState<any>([]);
  const [popularBlogs, setPopularBlogs] = useState<any>([]);

  // const [searchPhrase, setSearchPhrase] = useState("");
  const topicHandler = (event: any) => {
    let newTopic = topics.find((topic: any) => topic.topic === event.target.id);
    newTopic.isSelected = !newTopic.isSelected;
    setTopics((current: any) =>
      current.filter((topic: any) => topic.topic !== event.target.id)
    );
    setTopics((current: any) => [...current, newTopic]);
  };
  const [sortCriteria, setSortCriteria] = useState("Publish Date");
  const sortChangeHandler = (event: any) => {
    setSortCriteria(event.target.value);
  };

  const popularTopicHandler = (event: any) => {
    let newTopic = popularTopics.find(
      (topic: any) => topic.topic === event.target.id
    );
    newTopic.isSelected = !newTopic.isSelected;
    setPopularTopics((current: any) =>
      current.filter((topic: any) => topic.topic !== event.target.id)
    );
    setPopularTopics((current: any) => [...current, newTopic]);
  };
  const [popularSortCriteria, setPopularSortCriteria] =
    useState("Publish Date");
  const popularSortChangeHandler = (event: any) => {
    setPopularSortCriteria(event.target.value);
  };
  useEffect(() => {
    const fetchTopics = async () => {
      const query = new Parse.Query("Topic");

      try {
        const results = await query.find();

        results.forEach((topic: any, index: any) => {
          const newTopic = {
            topic: topic.get("topic"),
            isSelected: false,
            index: index,
          };

          setTopics((current: any) => {
            if (!current.find((cur: any) => cur.topic === newTopic.topic))
              return [...current, newTopic];
            else return [...current];
          });
        });
        // console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, []);
  useEffect(() => {
    const fetchTopics = async () => {
      const query = new Parse.Query("Topic");

      try {
        const results = await query.find();

        results.forEach((topic: any, index: any) => {
          const newTopic = {
            topic: topic.get("topic"),
            isSelected: false,
            index: index,
          };

          setTopics((current: any) => {
            if (!current.find((cur: any) => cur.topic === newTopic.topic))
              return [...current, newTopic];
            else return [...current];
          });
        });
        // console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
    const fetchPopularTopics = async () => {
      const query = new Parse.Query("Topic");

      try {
        const results = await query.find();

        results.forEach((topic: any, index: any) => {
          const newTopic = {
            topic: topic.get("topic"),
            isSelected: false,
            index: index,
          };

          setPopularTopics((current: any) => {
            if (!current.find((cur: any) => cur.topic === newTopic.topic))
              return [...current, newTopic];
            else return [...current];
          });
        });
        // console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPopularTopics();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      const query: any = new Parse.Query("Blog");
      if (topics.find((topic: any) => topic.isSelected))
        query.containedIn(
          "topics",
          topics.map((item: any) => {
            if (item.isSelected)
              return item.topic.trim().replace(/[^\x20-\x7E]/g, "");
          })
        );
      if (sortCriteria === "Alphabetical") {
        query.ascending("title");
      } else if (sortCriteria === "Most Likes") {
        query.descending("likeCount");
      } else {
        query.descending("createdAt");
      }
      if (props.searchPhrase) {
        query._where = {
          $or: [
            { author: { $regex: props.searchPhrase, $options: "i" } }, // Search in artistName
            { abstract: { $regex: props.searchPhrase, $options: "i" } }, // Search in description
            { title: { $regex: props.searchPhrase, $options: "i" } }, // Search in description
          ],
        };
      }
      try {
        const results = await query.find();
        setBlogs(results);
        // console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [props.searchPhrase, sortCriteria, topics]);
  useEffect(() => {
    const fetchPopularBlogs = async () => {
      const query: any = new Parse.Query("Blog");
      query.equalTo("isPress", true);

      if (popularTopics.find((topic: any) => topic.isSelected))
        query.containedIn(
          "topics",
          popularTopics.map((item: any) => {
            if (item.isSelected)
              return item.topic.trim().replace(/[^\x20-\x7E]/g, "");
          })
        );
      if (popularSortCriteria === "Alphabetical") {
        query.ascending("title");
      } else if (popularSortCriteria === "Most Likes") {
        query.descending("likeCount");
      } else {
        query.descending("createdAt");
      }
      if (props.searchPhrase) {
        query._where = {
          $or: [
            { author: { $regex: props.searchPhrase, $options: "i" } }, // Search in artistName
            { abstract: { $regex: props.searchPhrase, $options: "i" } }, // Search in description
            { title: { $regex: props.searchPhrase, $options: "i" } }, // Search in description
          ],
        };
      }
      try {
        const results = await query.find();
        setPopularBlogs(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPopularBlogs();
  }, [popularSortCriteria, popularTopics, props.searchPhrase]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
          sx={{ overflow: "scroll" }}
        >
          <StyledTab label="All topics" {...a11yProps(0)} />
          <StyledTab label="Press" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <div className={styles["topic-container"]}>
            {topics
              .toSorted((a: any, b: any) => {
                if (a.index < b.index) return -1;
                if (a.index > b.index) return 1;
                return 0;
              })
              .map((topic: any, index: any) => {
                if (!topic.isSelected)
                  return (
                    <button
                      key={index}
                      id={topic.topic}
                      className={styles.topic}
                      onClick={topicHandler}
                    >
                      {topic.topic}
                    </button>
                  );
                else
                  return (
                    <button
                      key={index}
                      id={topic.topic}
                      className={styles["selected-topic"]}
                      onClick={topicHandler}
                    >
                      {topic.topic}
                    </button>
                  );
              })}
          </div>
          <select
            name="sortBy"
            id="sortBy"
            className={styles.select}
            onChange={sortChangeHandler}
          >
            <option value="Publish Date">Publish Date</option>
            <option value="Alphabetical">Alphabetical</option>
            <option value="Most Likes">Most Likes</option>
          </select>
        </Box>
        <Grid
          container
          sx={{
            py: 3,
            display: "flex",
            // justifyContent: "",
            gap: "3.70%",
          }}
        >
          {blogs
            // .toSorted((a: any, b: any) => {
            //   if (sortCriteria === "Alphabetical") {
            //     if (a.get("title") < b.get("title")) return -1;
            //     if (a.get("title") > b.get("title")) return 1;
            //     return 0;
            //   } else if (sortCriteria === "Publish Date") {
            //     return a.get("publishDate") - b.get("publishDate");
            //   } else if (sortCriteria === "Most Likes") {
            //     return (b.get("likeCount") | 0) - (a.get("likeCount") | 0);
            //   } else return 0;
            // })
            .map((blog: any) => {
              return (
                <Grid md={3.7} xs={12} sm={5.8} sx={{ mb: 4 }}>
                  <Link to={`/blog/${blog.id}`}>
                    <Box
                      sx={{
                        width: "100%",
                        aspectRatio: 1,
                        backgroundColor: "gray",
                        mb: 1,
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={blog.get("thumbnail").url()}
                        alt=""
                        style={{ width: "100%" }}
                      />
                      <Box sx={{ position: "absolute", bottom: 4, left: 0 }}>
                        {blog.get("topics") &&
                          blog.get("topics").map((topic: any) => (
                            <Typography
                              sx={{
                                display: "inline",
                                backgroundColor: "#863a1d",
                                p: "8px 20px",
                                color: "white",

                                fontWeight: "1000",
                              }}
                            >
                              {topic}
                            </Typography>
                          ))}
                      </Box>
                    </Box>
                    <Typography component="h2" variant="h6">
                      {blog.get("title")}
                    </Typography>
                    <Typography
                      // component="h2"
                      variant="subtitle2"
                      sx={{ color: "#7f7f7f", display: "inline" }}
                    >
                      Author:{" "}
                    </Typography>
                    <Typography
                      // component="h2"
                      variant="subtitle2"
                      sx={{ display: "inline" }}
                    >
                      {blog.get("author")}
                    </Typography>
                    <Typography
                      // component="h2"
                      variant="subtitle1"
                      sx={{ color: "#863a1d" }}
                    >
                      {blog.get("readingTime")} min read ·{" "}
                      {blog.get("publishDate").toDateString()}
                    </Typography>
                  </Link>
                </Grid>
              );
            })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <div className={styles["topic-container"]}>
            {popularTopics
              .toSorted((a: any, b: any) => {
                if (a.index < b.index) return -1;
                if (a.index > b.index) return 1;
                return 0;
              })
              .map((topic: any, index: any) => {
                if (!topic.isSelected)
                  return (
                    <button
                      key={index}
                      id={topic.topic}
                      className={styles.topic}
                      onClick={popularTopicHandler}
                    >
                      {topic.topic}
                    </button>
                  );
                else
                  return (
                    <button
                      key={index}
                      id={topic.topic}
                      className={styles["selected-topic"]}
                      onClick={popularTopicHandler}
                    >
                      {topic.topic}
                    </button>
                  );
              })}
          </div>
          <select
            name="sortBy"
            id="sortBy"
            className={styles.select}
            onChange={popularSortChangeHandler}
          >
            <option value="Publish Date">Publish Date</option>
            <option value="Alphabetical">Alphabetical</option>
            <option value="Most Likes">Most Likes</option>
          </select>
        </Box>
        <Grid
          container
          sx={{
            py: 3,
            display: "flex",
            gap: "3.70%",
          }}
        >
          {popularBlogs
            .toSorted((a: any, b: any) => {
              if (popularSortCriteria === "Alphabetical") {
                if (a.get("title") < b.get("title")) return -1;
                if (a.get("title") > b.get("title")) return 1;
                return 0;
              } else if (popularSortCriteria === "Publish Date") {
                return a.get("publishDate") - b.get("publishDate");
              } else if (popularSortCriteria === "Most Likes") {
                return (b.get("likeCount") | 0) - (a.get("likeCount") | 0);
              } else return 0;
            })
            .map((blog: any) => {
              return (
                <Grid md={3.7} xs={12} sm={5.8} sx={{ mb: 4 }}>
                  <Link to={`/blog/${blog.id}`}>
                    <Box
                      sx={{
                        width: "100%",
                        aspectRatio: 1,
                        backgroundColor: "gray",
                        mb: 1,
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={blog.get("thumbnail").url()}
                        alt=""
                        style={{ width: "100%" }}
                      />
                      <Box sx={{ position: "absolute", bottom: 4, left: 0 }}>
                        {blog.get("topics") &&
                          blog.get("topics").map((topic: any) => (
                            <Typography
                              sx={{
                                display: "inline",
                                backgroundColor: "#863a1d",
                                p: "8px 20px",
                                color: "white",

                                fontWeight: "1000",
                              }}
                            >
                              {topic}
                            </Typography>
                          ))}
                      </Box>
                    </Box>
                    <Typography component="h2" variant="h6">
                      {blog.get("title")}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "#7f7f7f", display: "inline" }}
                    >
                      Author:{" "}
                    </Typography>
                    <Typography sx={{ display: "inline" }} variant="subtitle2">
                      {blog.get("author")}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: "#863a1d" }}>
                      {blog.get("readingTime")} min read ·{" "}
                      {blog.get("publishDate").toDateString()}
                    </Typography>
                  </Link>
                </Grid>
              );
            })}
        </Grid>
      </CustomTabPanel>
    </Box>
  );
};
export default BlogTab;
